export default __webpack_public_path__ + "static/media/open-sea-icon.ae0addbf.svg";